import { UPSwitchStyled } from './styles';
import { UPSwitchProps } from './types';

const UPSwitch = (props: UPSwitchProps): JSX.Element => {
  const { checked, onChange, disabled, id, testId } = props;
  return (
    <UPSwitchStyled
      checked={checked}
      onChange={onChange}
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      disabled={disabled}
      id={id}
      inputProps={{ 'data-testid': testId } as React.InputHTMLAttributes<HTMLInputElement>}
    />
  );
};

export default UPSwitch;
